import type { AnalyticsEventName } from './types';

/**
 * Given an event name, serialize it into a string.
 *
 * @param eventName A tuple that represents an event, in the format of [Verb, Noun].
 * @returns A serialized event name.
 */
export function serializeEventName(eventName: AnalyticsEventName): string {
  if (typeof eventName === 'string') return eventName;

  const [verb, noun] = eventName;
  return [noun, verb].join('_');
}
